import {
  computed,
  EventEmitter,
  Injectable,
  Output,
  signal,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  @Output() dateUpdated = new EventEmitter<string>();

  private getLocalDateString(): string {
    const date = new Date();
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split('T')[0];
  }

  selectedDate = signal<string>(this.getLocalDateString());
  lastSelectedDay = signal<{ day: number; month: number; year: number } | null>(
    null
  );

  handleSelectedDate(date: string) {
    this.selectedDate.set(date);
    this.dateUpdated.emit(date);
  }

  currentDateValidGanadazo = computed(() => {
    // const date = this.calendarServcie.selectedDate() //YYYYMMDD

    // return true
    const selected = this.selectedDate(); // formato: 'YYYY-MM-DD'

    if (!selected) return false;

    const selectedDate = new Date(selected);
    const today = new Date();

    // Limpiar las horas para comparar solo fechas
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    const diffInMs = selectedDate.getTime() - today.getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays >= 0 && diffInDays <= 6;
  });

  handlePreviousDate() {
    const date = new Date(this.selectedDate());
    date.setDate(date.getDate() - 1);
    this.handleSelectedDate(date.toISOString().split('T')[0]);
  }

  restoreToday() {
    this.handleSelectedDate(this.getLocalDateString());
  }
}
